import type { Role } from '@bia-auction/shared-schema';

/**
 * Bidder-side role helpers (docs/08 permissions matrix). Roles are additive tags with no
 * hierarchy; the server re-checks every action, so these only decide which controls to show.
 */

/** A GOLDBIDDER (or admin) bypasses the per-lot deposit; a plain USER/BIDDER must fund one. */
export function bypassesDeposit(roles: Role[]): boolean {
  return roles.some((r) => r === 'GOLDBIDDER' || r === 'ADMIN' || r === 'DEVELOPER');
}

/** Already holds a paid membership (no purchase needed). */
export function isMember(roles: Role[]): boolean {
  return roles.includes('GOLDBIDDER');
}

/** Holds a lot deposit or is deposit-exempt → the bid controls are worth showing. */
export function mayBid(roles: Role[]): boolean {
  return roles.some(
    (r) => r === 'BIDDER' || r === 'GOLDBIDDER' || r === 'ADMIN' || r === 'DEVELOPER',
  );
}
